import util   from '../../common/AppUtil';

const ServerMode = 0;
const ApiCode = "XUser";

export default {
  getProfile: function(params) {
    return util.callServerPost(ServerMode,ApiCode,params,"userread");
  },
  saveProfile: function(params) {
    return util.callServerPost(ServerMode,ApiCode,params,"usersave");
  }

};
  


// WEBPACK FOOTER //
// ./src/api/system/xprofile.js